module.exports = __webpack_public_path__ + "img/badge-list-thumb-147.254b67ee.png";